<template>
  <div class="Error404">Error404</div>
</template>

<script>
export default {
  name: "Error404",
};
</script>

<style></style>
